// Alias de tipo de campo del Inventario — ESPEJO EXACTO del backend.
//
// Fuente de verdad: Servidor_Cursos_Sepe/inventario/services/schemaValidator.js
//   (const FIELD_TYPE_ALIASES, líneas 52-54).
//
// Contexto: el frontend usaba 'empresa_link', pero el backend lo canonicaliza
// a 'company_link' ANTES de validar y de persistir, así que en BBDD el
// fields_schema guarda SIEMPRE el tipo canónico. Para que el editor de tipos
// haga round-trip correcto (leer lo que el backend escribió y volver a
// guardarlo sin mutarlo) debe hablar el MISMO vocabulario canónico.
//
// Regla de mantenimiento: si en el backend se añade o cambia un alias en
// FIELD_TYPE_ALIASES, replícalo AQUÍ y solo aquí. No repartas alias por otros
// componentes: esa dispersión fue la causa raíz del bug de round-trip que
// hacía "desaparecer" los campos empresa_link al reabrir un tipo.
export const FIELD_TYPE_ALIASES = {
  empresa_link: 'company_link',
};

// Devuelve el tipo canónico de un alias, o el mismo tipo si no es alias.
export function canonicalType(type) {
  return FIELD_TYPE_ALIASES[type] || type;
}
